export class TTCoordinate {

    constructor(
        public coordinate: number[],
        public coordinateSystem: string,
        public coordinateAsString: string
    ) { }

    getCoordinate() {
        return this.coordinate;
    }

    getCoordinateSystem() {
        return this.coordinateSystem;
    }

    getCoordinateAsString() {
        return this.coordinateAsString;
    }

}